import type { FaireProductEntity } from "../../entity_types/product";

export const p_xw64qza9gv: FaireProductEntity = {
  token: "p_xw64qza9gv",
  type: "product",
  name: "Yoga Essential Oil Warmer for Aromatherapy and Relaxation",
  brandToken: "b_qqbr958t4u",
  brandName: "My Wholesale Gifts",
  imageUrl: "https://cdn.faire.com/fastly/e1e0d6d91cd59d86f6ca29fc3a5ebe9a7a3a03aaf4f1cc8cb44ef8b21235d58b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c49c731d03a2405181dcdff58234bc4b39d8957e1ca3ed3d5d02d394c57c8af5.jpeg"
  ],
  priceDollars: 34.12,
  description: "Elevate your yoga practice with our Yoga Essential Oil Warmer, designed for aromatherapy and relaxation. This sleek and stylish warmer is perfect for infusing your space with calming scents to enhance your practice. Whether you're looking to unwind after a long day or create a peaceful atmosphere for meditation, our essential oil warmer is the perfect addition to your yoga routine.\n• Oil warmer weighs 1.2 lbs. And measures 4.5 inches by 4.5 inches by 4.75 inches. Fits perfectly on a shelf or table as meditative d&eacute;cor.\n• The oil warmer is made from polyresin and glass that provides gorgeous sculptural details and an encompassing aroma.\n• Design a peaceful and aromatic ambience by warming and diffusing the essential oils of your choice. Simply pour your favorite scented oil into the top and light a candle underneath to create a tranquil and perfumed environment.\n• Clean with soap and water to remove remaining fragrance oils and candle residue before next use.\n• Perfect as a gift to use during meditation, yoga, or to simply make your home smell amazing. It works with practically any essential oil so feel free to create your own unique scents.",
  tags: [],
  msrpDollars: 49.82,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:03.510Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
